import { Injectable } from '@angular/core';
import { Globals } from '../../globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Attachment } from '../modal/approved';

@Injectable({
    providedIn: 'root'
})

export class AttachmentService {
    constructor(private global: Globals, private _httpClient: HttpClient) { }

  

  SaveAttchment(attchment: Attachment) {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this._httpClient.post<Attachment>(this.global.G_apiUrl +'/attachment',attchment,{headers:headers});
    }
}